module.exports = __webpack_public_path__ + "img/4.70a86a79.png";